import formatter from "./formatter";

export const zonesToOptions = (zones = []) => {
    return zones.map((zone) => {
        return {
            key: zone.id,
            text: formatter.translate(zone.active ? 'booker:zone_active' : 'booker:zone_inactive', { name: zone.name }),
            value: zone.id,
            label: {
                color: (zone.active)?'green':'red',
                empty: true,
                circular: true,
                size: 'mini'
            },
        };
    });
};


export const zonesToOptionsWithAll = (zones = []) => {
    const options = zonesToOptions(zones);
    const allId = -1;
    options.push({
        key: allId,
        text: formatter.translate('booker:zone_picker.all_zones'),
        value: allId,
        label: {
            color: 'blue',
            empty: true,
            circular: true,
            size: 'mini'
        },
    });
    return options;
}

export const orderZonesByName = (zones = []) => zones.sort((a, b) => a.name.localeCompare(b.name));

export function makeUniqueZoneById(zones, newZone) {

    const isNewZoneDefault = newZone.is_default;

    if (!isNewZoneDefault)
        return zones;
    
    return zones.map(zone => ({ ...zone, is_default: zone.id === newZone.id, }));
}

export function findDefaultZone(zones) {
    return zones.find(zone => zone.is_default);
}


// WEBPACK FOOTER //
// ./src/helpers/zones.js